import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { ICapability, ICapabilityFormValues } from '../../types/capability'
import { IPublishingLocation } from '../../types/publishingLocations'
import { push } from '../../actions/router'
import { createCapability } from '../../actions/capability'
import { initialState } from '../../reducers/capability'
import {
  transformCapabilityInputToState,
  transformCapabilityStateToInput,
} from '../../services/capability'
import { capabilityValidationSchema } from '../CapabilityForm/validation'
import { NavigationGuard } from '../../components'
import { CapabilityForm } from '../CapabilityForm'

export interface ICreateCapabilityForm {
  capability: ICapability
  publishingLocations: IPublishingLocation[]
  dispatch: Dispatch
}

export const CreateCapabilityForm = ({
  capability,
  publishingLocations,
  dispatch,
}: ICreateCapabilityForm) =>
  !capability.isLoading ? (
    <Formik
      initialValues={transformCapabilityStateToInput(initialState)}
      validationSchema={capabilityValidationSchema}
      onSubmit={(values: ICapabilityFormValues) =>
        dispatch(
          createCapability(
            transformCapabilityInputToState(values, publishingLocations)
          )
        )
      }
      render={(formikProps) => (
        <>
          <CapabilityForm
            formikProps={formikProps}
            cancelAction={() => {
              formikProps.resetForm()
              dispatch(push('/settings/capabilities?tab=all-capabilities'))
            }}
            submitText="Create new capability"
          />
          <NavigationGuard isBlocking={formikProps.dirty} />
        </>
      )}
    />
  ) : null
